const CAMERA_LIMITS = {
  lng: [-180, 180],
  lat: [-90, 90],
  zoom: [4, 14],
  pitch: [0, 60],
  bearing: [-180, 180],
};

export const readPermalinkCamera = (search) => {
  const params = new URLSearchParams(search);
  const keys = Object.keys(CAMERA_LIMITS);
  if (!keys.some((key) => params.has(key))) return null;

  const values = {};
  for (const key of keys) {
    const raw = params.get(key);
    const value = Number(raw);
    const [min, max] = CAMERA_LIMITS[key];
    if (raw == null || raw.trim() === "" || !Number.isFinite(value) || value < min || value > max) {
      console.warn(`Invalid live map permalink camera parameter: ${key}`);
      return null;
    }
    values[key] = value;
  }

  return {
    center: [values.lng, values.lat],
    zoom: values.zoom,
    pitch: values.pitch,
    bearing: values.bearing,
  };
};

export const createPermalink = (href, game, map) => {
  const url = new URL(href);
  const center = map.getCenter().wrap();
  url.searchParams.set("game", game);
  url.searchParams.set("lng", String(center.lng));
  url.searchParams.set("lat", String(center.lat));
  url.searchParams.set("zoom", String(map.getZoom()));
  url.searchParams.set("pitch", String(map.getPitch()));
  url.searchParams.set("bearing", String(map.getBearing()));
  return url.toString();
};
